import { VERSION } from "./lib/utils/version.js";
import { encodeWKTCRS } from "./lib/encode-wkt-crs.js";
export const WKTCRSWriter = {
  name: 'WKT CRS (Well-Known Text Coordinate Reference System)',
  id: 'wkt-crs',
  module: 'wkt-crs',
  version: VERSION,
  worker: true,
  extensions: [],
  mimeTypes: ['text/plain'],
  text: true,
  options: {
    'wkt-crs': {}
  },
  encode: async (wktcrs, options) => new TextEncoder().encode(encodeWKTCRS(wktcrs, options === null || options === void 0 ? void 0 : options['wkt-crs'])),
  encodeSync: (wktcrs, options) => new TextEncoder().encode(encodeWKTCRS(wktcrs, options === null || options === void 0 ? void 0 : options['wkt-crs'])),
  encodeTextSync: (wktcrs, options) => encodeWKTCRS(wktcrs, options === null || options === void 0 ? void 0 : options['wkt-crs'])
};
//# sourceMappingURL=wkt-crs-writer.js.map